import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { ComponentBaseService } from './component-base.service'
import { ServicesConstants } from '../services-constants'
import { Parametro } from '../_models/parametro';
import { Utils } from '../utils';
import { delayedRetry } from './delayed-retry';

@Injectable()
export class ParametroService extends ComponentBaseService {

  constructor(
    private http: HttpClient
  ) {
    super();
  }

  getServiceName(): string {
    return "ParametroService";
  }

  /** GET Parametro by id. Will 404 if id not found */
  getElencoParametri(): Observable<Parametro[]> {
    let url = `${ServicesConstants.URL_PARAMETRI}`;

    return this.http.get<Parametro[]>(url).pipe(
      delayedRetry(),
      tap(_ => this.log(`fetched Elenco Parametri`)),
      catchError(this.handleError<Parametro[]>(`getElencoParametri`))
    );
  }

  /** GET Parametro by id. Will 404 if id not found */
  getParametro(nomeParametro: string): Observable<Parametro> {
    const url = `${ServicesConstants.URL_PARAMETRI}/${nomeParametro}`;
    return this.http.get<Parametro>(url).pipe(
      delayedRetry(),
      tap(_ => this.log(`fetched Parametro nomeParametro=${nomeParametro}`)),
      catchError(this.handleError<Parametro>(`getParametro id=${nomeParametro}`))
    );
  }

  //////// Save methods //////////

  /** PUT: update the Parametro on the server */
  updateParametro(parametro: Parametro): Observable<any> {
    const url = `${ServicesConstants.URL_PARAMETRI}/${parametro.nomeParametro}`;

    return this.http.put(url, parametro, this.httpOptions).pipe(
      tap(_ => this.log(`updated Parametro id=${parametro.nomeParametro}`)),
      catchError(this.handleError<any>('updateParametro'))
    );
  }

}


// WEBPACK FOOTER //
// ./src/app/_services/parametro.service.ts